import React, { useCallback, useContext, useState, useEffect } from "react";
import { Checkbox, Dimmer, Dropdown, Loader, CardContent } from "semantic-ui-react";
import { usePlaidLink } from "react-plaid-link";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { AppContext } from "../../context/app/appContext";
import moment from "moment";
import { Grid, Card, Container, Button, Modal } from 'semantic-ui-react'

export const MyOrgPaymentSetup = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");

  const [acceptTermsAndConditions, setAcceptTermsAndConditions] = useState(
    false
  );

  const appContext = useContext(AppContext);

  const baseURL = process.env.NODE_ENV === "production" ? process.env.REACT_APP_API_HOST_URL : "http://localhost:8080";

  const [activePaymentMethod, setActivePaymentMethod] = useState("plaid"); // plaid | creditCard | manualBankVerification

  const countries = [{ key: 1, value: "US", text: "United States" }];

  const bankAccountTypes = [
    { key: 1, value: "company", text: "Business (recommended)" },
    { key: 2, value: "individual", text: "Individual" },
  ];
  const [cardHolderName, setCardHolderName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiryMonth, setExpiryMonth] = useState("");
  const [expiryYear, setExpiryYear] = useState("");
  const [cvc, setCvc] = useState("");
  const [bankAccountCountry, setBankAccountCountry] = useState(countries[0].value);
  const [bankAccountHolderName, setBankAccountHolderName] = useState("");
  const [bankAccountHolderType, setBankAccountHolderType] = useState(bankAccountTypes[0].value);
  const [bankAccountRoutingNumber, setBankAccountRoutingNumber] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");

  const [showMicroDepositForm, setShowMicroDepositForm] = useState(false);
  const [firstMicroDepositAmount, setFirstMicroDepositAmount] = useState(0);
  const [secondMicroDepositAmount, setSecondMicroDepositAmount] = useState(0);
  const [taxId, setTaxId] = useState("");
  const [primaryContactSSN, setPrimaryContactSSN] = useState("");
  const [paymentSourceIdToVerify, setPaymentSourceIdToVerify] = useState("");
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const [showDefault, setShowDefault] = useState(null);
  const [indexSelected, setIndexSelected] = useState(0);
  const [isopen, setOpen] = useState(false)
  const [paymentCount, setpaymentCount] = useState(0)

  // const [isverify, setVerify] = useState(false)

  console.log("appContext", appContext)
  const [listOfPaymentSources, setListOfPaymentSources] = useState(appContext.organization.paymentSources !== undefined ? appContext.organization.paymentSources : []);

  useEffect(() => {
    if (appContext.organization.verified === true) {
      console.log("*&@#$%%%%%%%%%");
      (async function loadTeams() {
        await getDefaultPaymentMethod();
      })();
    }
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (appContext.organization.verified === true) {
      console.log("*&@#$%%%%%%####%%%");
      (async function loadTeams() {
        await getDefaultPaymentMethod();
      })();
    }
    // eslint-disable-next-line
  }, [appContext.organization.verified]);
  console.log("paymentCount", paymentCount)

  useEffect(() => {
    if (listOfPaymentSources) {
      setpaymentCount(listOfPaymentSources.length)

    }
  }, [listOfPaymentSources])

  useEffect(() => {
    var temp = listOfPaymentSources.map((ps) => { return { ...ps, isPrimary: ps.id === showDefault ? 1 : 2 } })
    console.log("New", temp)
    setListOfPaymentSources(temp)
    setpaymentCount(listOfPaymentSources.length)
    console.log("Hello I am here")
    console.info({ listOfPaymentSources })
  }, [showDefault]);

  useEffect(() => {
    setListOfPaymentSources(appContext.organization.paymentSources);
    console.log("Wohoo")
    console.info({ listOfPaymentSources });
  }, [appContext.organization]);

  const onVerifyPaymentSource = (paymentSourceId, index) => {
    setPaymentSourceIdToVerify(paymentSourceId);
    setShowMicroDepositForm(true);

  };

  const deletePaymentSource = async (paymentSourceId) => {
    const accessToken = localStorage.getItem("accessToken");
    try {
      const body = {
        stripeCustomerId: appContext.organization.stripeCustomer.id,
        paymentSourceId,
      };
      const deletedPaymentSource = await axios.post(`${baseURL}/delete-payment-source`, body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      console.log("useState list", listOfPaymentSources);
      const newList = listOfPaymentSources;
      console.log("newList", newList);
      const itemIndex = newList.findIndex((item) => item.id === paymentSourceId);
      console.log("index", itemIndex);
      console.info({ deletedPaymentSource });
      if (itemIndex > -1) {
        newList.splice(itemIndex, 1);
      }
      console.log("After deleting", [...newList]);
      setListOfPaymentSources([...newList]);
      setpaymentCount(prevCount => prevCount - 1)
      console.info({ listOfPaymentSources })
      // return listOfPaymentSources;
    } catch (error) {
      console.info({ error });
    }
  };

  const getDefaultPaymentMethod = async () => {
    try {
      const accessToken = localStorage.getItem("accessToken");

      const customerResponse = await axios.get(`${baseURL}/default-payment-method`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      console.info({ customerResponse })

      for (const paymentSource of customerResponse.data.paymentSources) {
        // console.log(paymentSource.id);
        if (customerResponse.data.stripeCustomer.default_source === paymentSource.id) {
          setShowDefault(paymentSource.id);
          console.log("Checking payment source")
          console.log(paymentSource)

        } else {
          //   console.log("Not a default method");
          //   setShowDefault(null);
        }
      };

      //   console.log(customerResponse);
    } catch (error) {
      console.log(error);
      return false;
    }
  };


  const handlePaymentSourceVerification = async (e) => {
    e.preventDefault();
    console.info({ paymentSourceIdToVerify });
    setErrors("");
    setLoading(true);
    try {
      const accessToken = localStorage.getItem("accessToken");
      const parameters = {
        paymentSourceId: paymentSourceIdToVerify,
        firstMicroDepositAmount,
        secondMicroDepositAmount,
        taxId,
        primaryContactSSN,
        // taxId: appContext.organization.EIN,
        // primaryContactSSN: appContext.organization.primaryContact.ssn || "",
      };
      const paymentSourceVerified = await axios.post(`${baseURL}/organization/verify-payment-source`, parameters, { headers: { Authorization: `Bearer ${accessToken}` } });
      if (paymentSourceVerified && paymentSourceVerified.data && paymentSourceVerified.status === 200) {
        setLoading(false);
        console.info({ paymentSourceVerified: paymentSourceVerified.data });
        const { code, message } = paymentSourceVerified.data.status;
        if (code && code === `organization/payment-source-verified`) {
          setErrors(message);
          setShowMicroDepositForm(false);

          const updatedPaymentSources = appContext.organization.paymentSources.map(
            (paymentSource) => {
              if (paymentSource.id === paymentSourceIdToVerify)
                return { ...paymentSource, status: "verified" };
              return paymentSource;
            }
          );

          setPaymentSourceIdToVerify("")
          console.info(`After verification:`, { updatedPaymentSources });
          const orgWithVerifiedPaymentSource = { ...appContext.organization, paymentSources: updatedPaymentSources };
          console.info({ orgWithVerifiedPaymentSource });
          await appContext.setOrganizationPartialInfo(orgWithVerifiedPaymentSource);
        }

        if (code && code == "organization/first-source-verified") {
          setErrors(message);
          setShowMicroDepositForm(false);

          const updatedPaymentSources = appContext.organization.paymentSources.map(
            (paymentSource) => {
              if (paymentSource.id === paymentSourceIdToVerify)
                return { ...paymentSource, status: "verified" };
              return paymentSource;
            }
          );

          console.info(`After verification:`, { updatedPaymentSources });
          var oldStripe = appContext.organization.stripe;
          oldStripe['accountId'] = paymentSourceVerified.data.data.accountId;
          const orgWithVerifiedPaymentSource = { ...appContext.organization, paymentSources: updatedPaymentSources, verified: true, stripe: oldStripe };
          console.info({ orgWithVerifiedPaymentSource });
          await appContext.setOrganizationPartialInfo(orgWithVerifiedPaymentSource);
        }
        // history.push(`/my-org/user-settings`);
      }
    } catch (error) {
      setLoading(false);
      console.info({ error });
      if (error.response && error.response.data && error.response.data.status && error.response.data.status.message) setErrors(error.response.data.status.message);
      if (error.response && error.response.data && error.response.data.status && error.response.data.status.data) {
        const fieldsErrors = error.response.data.status.data.map((error) => error.message);
        const errorString = fieldsErrors.toString();
        setErrors(errorString);
      }
    }
  };

  const resetPaymentSourceVerificationForm = () => {
    setFirstMicroDepositAmount(0);
    setSecondMicroDepositAmount(0);
    setTaxId("");
    setPrimaryContactSSN("");
    setPaymentSourceIdToVerify("");
    setShowMicroDepositForm(false);
    console.info({ paymentSourceIdToVerify });
  };

  const resetBankaccountInfoForm = () => {
    setBankAccountCountry(countries[0].value);
    setBankAccountHolderName("");
    setBankAccountHolderType(bankAccountTypes[0].value);
    setBankAccountNumber("");
    setBankAccountRoutingNumber("");
    setActivePaymentMethod("plaid");
    console.info({ bankAccountCountry });
  };

  const resetCardInfoForm = () => {
    setCardHolderName("");
    setCardNumber("");
    setCvc("");
    setExpiryMonth("");
    setExpiryYear("");
  };

  const microDepositForm = (
    <div className="ui segment">
      <form className="ui form" onSubmit={handlePaymentSourceVerification}>
        <div className="inline fields">
          <div className="field four wide">
            <label>Tax ID *</label>
          </div>
          <div className="field eight wide">
            <input type="text" required value={taxId} onChange={(e) => setTaxId(e.target.value)} />
          </div>
        </div>
        <div className="inline fields">
          <div className="field four wide">
            <label>SSN *</label>
          </div>
          <div className="field eight wide">
            <input type="number" required value={primaryContactSSN} onChange={(e) => setPrimaryContactSSN(e.target.value)} />
          </div>
        </div>
        <div className="inline fields">
          <div className="field four wide">
            <label>First Micro Deposit Amount *</label>
          </div>
          <div className="field eight wide">
            <input type="number" required value={firstMicroDepositAmount} onChange={(e) => setFirstMicroDepositAmount(e.target.value)} />
          </div>
        </div>
        <div className="inline fields">
          <div className="field four wide">
            <label>Second Micro Deposit Amount *</label>
          </div>
          <div className="field eight wide">
            <input type="number" required value={secondMicroDepositAmount} onChange={(e) => setSecondMicroDepositAmount(e.target.value)} />
          </div>
        </div>

        <button className="ui button primary" type="submit">Submit</button>
        <button className="ui button" onClick={(e) => resetPaymentSourceVerificationForm()}>Cancel</button>
      </form>
    </div>
  );

  const creditCardInfo = (
    <form className="ui form">
      <div className="inline fields">
        <div className="inline fields">
          <div className="field three wide">
            <label>Card holder name *</label>
          </div>
          <div className="field eight wide">
            <input type="text" required value={cardHolderName} onChange={(e) => setCardHolderName(e.target.value)} />
          </div>
        </div>

        <div className="field three wide">
          <label>Card Number *</label>
        </div>
        <div className="field eight wide">
          <input type="text" required value={cardNumber} onChange={(e) => setCardNumber(e.target.value)} />
        </div>
      </div>

      <div className="inline fields">
        <div className="field three wide">
          <label>Expiry Month *</label>
        </div>
        <div className="field eight wide">
          <input type="text" value={expiryMonth} onChange={(e) => setExpiryMonth(e.target.value)} required />
        </div>
      </div>

      <div className="inline fields">
        <div className="field three wide">
          <label>Expiry Year *</label>
        </div>
        <div className="field eight wide">
          <input type="text" value={expiryYear} onChange={(e) => setExpiryYear(e.target.value)} required />
        </div>
      </div>

      <div className="inline fields">
        <div className="field three wide">
          <label>Enter cvc *</label>
        </div>
        <div className="field eight wide">
          <input type="text" value={cvc} onChange={(e) => setCvc(e.target.value)} required />
        </div>
      </div>
    </form>
  );

  const bankAccountInfo = (
    <form className="ui form">
      <div className="inline fields">
        <div className="field three wide">
          <label>Account holder name *</label>
        </div>
        <div className="field eight wide">
          <input type="text" required value={bankAccountHolderName} onChange={(e) => setBankAccountHolderName(e.target.value)} />
        </div>
      </div>

      <div className="inline fields">
        <div className="field three wide">
          <label>Account holder type *</label>
        </div>

        <Dropdown className="ui input" options={bankAccountTypes} value={bankAccountHolderType} required selection onChange={(e, { value }) => setBankAccountHolderType(value)} />

        <div className="field eight wide"></div>
      </div>

      <div className="inline fields">
        <div className="field three wide">
          <label>Routing Number *</label>
        </div>
        <div className="field eight wide">
          <input type="text" value={bankAccountRoutingNumber} onChange={(e) => setBankAccountRoutingNumber(e.target.value)} required />
        </div>
      </div>

      <div className="inline fields">
        <div className="field three wide">
          <label>Account Number *</label>
        </div>
        <div className="field eight wide">
          <input type="text" value={bankAccountNumber} onChange={(e) => setBankAccountNumber(e.target.value)} required />
        </div>
      </div>

      <div className="inline fields">
        <div className="field three wide">
          <label>Country *</label>
        </div>

        <Dropdown className="ui input" value={bankAccountCountry} options={countries} required selection onChange={(e, { value }) => setBankAccountCountry(value)} />

        <div className="field eight wide"></div>
      </div>
    </form>
  );

  const submitCardInfo = async (token = null, metadata = null) => {
    setLoading(true);
    setErrors("");
    console.info({ activePaymentMethod });
    console.info({ token }, { metadata });

    // const accountId = metadata.account_id != null ? metadata.account_id : metadata.accounts[0]['id'];
    // const withPlaidData = {
    //   plaidAccountToken: token,
    //   plaidAccountID:
    //     metadata && metadata.account_id ? metadata.account_id : null,
    // };



    const cardData = {
      paymentMethod: activePaymentMethod,
      cardHolderName,
      cardNumber,
      expiryMonth,
      expiryYear,
      cvc,
    };

    console.info({ unverifiedOrg: appContext.organization });
    // console.info({ stripeCustomer: appContext.organization.stripeCustomer });

    try {
      const accessToken = localStorage.getItem("accessToken");

      let params = {
        // paymentMethod: activePaymentMethod,
        unverifiedAccountToken: appContext.user.accessToken,

        legalEntityName: appContext.organization.legalEntityName,
        entityType: appContext.organization.entityType,
        website: appContext.organization.website,
        merchantCategoryCode: appContext.organization.merchantCategoryCode,
        taxId: appContext.organization.EIN,
        street: appContext.organization.street,
        city: appContext.organization.city,
        state: appContext.organization.state,
        country: appContext.organization.country,
        zip: appContext.organization.zip,

        primaryContactFirstName: appContext.organization.primaryContact.firstName,
        primaryContactLastName: appContext.organization.primaryContact.lastName,
        primaryContactNumber: appContext.organization.primaryContact.contactNumber,
        primaryContactEmail: appContext.organization.primaryContact.email,
        primaryContactLinkedInProfile: appContext.organization.primaryContact.linkedInProfile,
        primaryContactSignatoryType: appContext.organization.primaryContact.signatoryType,
        primaryContactSSN: appContext.organization.primaryContact.ssn,
        primaryContactDateOfBirth: moment(appContext.organization.primaryContact.primaryContactDOB).format("YYYY-MM-DD"),

        secondaryContactFirstName: appContext.organization.secondaryContact.firstName,
        secondaryContactLastName: appContext.organization.secondaryContact.lastName,
        secondaryContactNumber: appContext.organization.secondaryContact.contactNumber,
        secondaryContactEmail: appContext.organization.secondaryContact.email,
        secondaryContactLinkedInProfile: appContext.organization.secondaryContact.linkedInProfile,
      };

      const paramsNonVerified = { ...params, ...cardData }
      const paramsVerified = { ...cardData };

      // console.info({ params });

      console.info({ paramsVerified })

      let creditCardAdded;
      if (appContext.organization.stripe !== undefined) {
        console.log("Credit card")
        creditCardAdded = await axios.post(`${baseURL}/organization/payment-methods/add-card`, paramsVerified, { headers: { Authorization: `Bearer ${accessToken}` } });
        console.info({ creditCardAdded });
        if (creditCardAdded && creditCardAdded.data && creditCardAdded.status === 200) {
          setLoading(false);
          // setListOfPaymentSources([...listOfPaymentSources, ...creditCardAdded.data.data])
          // setpaymentCount(prevCount => prevCount + 1)
          const { code, message } = creditCardAdded.data.status;
          console.info({ code, message });
          setErrors(message);
          if (code === "organization/payment-method-card-added") {
            console.info(`code === 'organization/payment-method-card-added' ${code === "organization/payment-method-card-added"}`);
            // resetPaymentSourceVerificationForm();
            setShowMicroDepositForm(false);
            setListOfPaymentSources([...listOfPaymentSources, creditCardAdded.data.data])
            setpaymentCount(prevCount => prevCount + 1)
            const paymentSources = [...listOfPaymentSources, creditCardAdded.data.data];
            console.info({ paymentSources });
            await appContext.setOrganizationPartialInfo({ ...appContext.organization, paymentSources });
          }


        }
      } else {
        creditCardAdded = await axios.post(`${baseURL}/register-organization`, paramsNonVerified, { headers: { Authorization: `Bearer ${accessToken}` } });
        console.info({ creditCardAdded });
        if (creditCardAdded && creditCardAdded.data && creditCardAdded.status === 200) {
          setLoading(false);

          const { code, message } = creditCardAdded.data.status;
          console.info({ code, message });
          setErrors(message);
          if (code === "organization/registered") {
            setListOfPaymentSources(creditCardAdded.data.data.paymentSources)
            setpaymentCount(prevCount => prevCount + 1)
            const paymentSources = creditCardAdded.data.data.paymentSources;
            console.info({ paymentSources });
            await appContext.setVerifiedUser(creditCardAdded.data.data.user);
            await appContext.setOrganization(creditCardAdded.data.data.user.accessToken)
            localStorage.setItem('accessToken', creditCardAdded.data.data.user.accessToken);
            localStorage.setItem('email', creditCardAdded.data.data.user.email);
          }
        }
      }
    } catch (error) {
      console.info({ error });
      setLoading(false);
      if (error.response && error.response.data && error.response.data.status && error.response.data.status.message) setErrors(error.response.data.status.message);
    }
    // setTransactions(accountAttached.data.transactions.transactions);
  };

  const submitAccountInfo = async (token = null, metadata = null) => {
    setLoading(true);
    setErrors("");
    console.info({ activePaymentMethod });
    console.info({ token }, { metadata });
    console.log("Checking app context", appContext)

    // const accountId = metadata.account_id != null ? metadata.account_id : metadata.accounts[0]['id'];
    const withPlaidData = {
      paymentMethod: activePaymentMethod,
      plaidAccountToken: token,
      plaidAccountID: metadata && metadata.account_id ? metadata.account_id : null,
    };

    const withoutPlaidData = {
      paymentMethod: activePaymentMethod,
      bankAccountCountry,
      bankAccountHolderName,
      bankAccountHolderType,
      bankAccountRoutingNumber,
      bankAccountNumber,
    };

    console.info({ unverifiedOrg: appContext.organization });
    // console.info({ stripeCustomer: appContext.organization.stripeCustomer });

    try {
      const accessToken = localStorage.getItem("accessToken");

      let params = {
        // paymentMethod: activePaymentMethod,
        unverifiedAccountToken: appContext.user.accessToken,
        legalEntityName: appContext.organization.legalEntityName,
        entityType: appContext.organization.entityType,
        website: appContext.organization.website,
        merchantCategoryCode: appContext.organization.merchantCategoryCode,
        taxId: appContext.organization.EIN,
        street: appContext.organization.street,
        city: appContext.organization.city,
        state: appContext.organization.state,
        country: appContext.organization.country,
        zip: appContext.organization.zip,

        primaryContactFirstName: appContext.organization.primaryContact.firstName,
        primaryContactLastName: appContext.organization.primaryContact.lastName,
        primaryContactNumber: appContext.organization.primaryContact.contactNumber,
        primaryContactEmail: appContext.organization.primaryContact.email,
        primaryContactLinkedInProfile: appContext.organization.primaryContact.linkedInProfile,
        primaryContactSignatoryType: appContext.organization.primaryContact.signatoryType,
        primaryContactSSN: appContext.organization.primaryContact.ssn,
        primaryContactDateOfBirth: moment(appContext.organization.primaryContact.primaryContactDOB).format("YYYY-MM-DD"),

        secondaryContactFirstName: appContext.organization.secondaryContact.firstName,
        secondaryContactLastName: appContext.organization.secondaryContact.lastName,
        secondaryContactNumber: appContext.organization.secondaryContact.contactNumber,
        secondaryContactEmail: appContext.organization.secondaryContact.email,
        secondaryContactLinkedInProfile: appContext.organization.secondaryContact.linkedInProfile,
      };

      var paramsNonVerified = activePaymentMethod === "plaid" ? { ...params, ...withPlaidData } : { ...params, ...withoutPlaidData };

      var paramsVerified = activePaymentMethod === "plaid" ? { ...withPlaidData } : { ...withoutPlaidData }

      let organizationCreated;
      console.log("New appcontext stripe", appContext.organization.stripe);
      if (appContext.organization.stripe !== undefined) {
        organizationCreated = await axios.post(`${baseURL}/add-bank`, paramsVerified, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        console.log("add bank")
        if (organizationCreated && organizationCreated.data && organizationCreated.status === 200) {
          // console.info(`register-organization`, organizationCreated.data);
          setLoading(false);
          const { code, message } = organizationCreated.data.status;
          console.info({ code, message });
          setListOfPaymentSources([...listOfPaymentSources, organizationCreated.data.data])
          setpaymentCount(prevCount => prevCount + 1)
          console.log("list of payment sources", listOfPaymentSources)
          setErrors(message);
          // if (code === "bankAccount/pending-verification") {
          //   console.log("Pending")
          //   console.info(`code === 'bankAccount/pending-verification' ${code === "bankAccount/pending-verification"}`);
          //   resetPaymentSourceVerificationForm();
          //   resetBankaccountInfoForm();
          //   setShowMicroDepositForm(false);

          //   const paymentSources = organizationCreated.data.data.paymentSources;
          //   console.info({ paymentSources });
          //   return await appContext.setOrganizationPartialInfo({ ...appContext.organization, paymentSources, });
          // }

          if (code === "organization/payment-method-bank-added") {
            resetPaymentSourceVerificationForm();
            resetBankaccountInfoForm();
            setShowMicroDepositForm(false)
            // const paymentSources = organizationCreated.data.data;
            appContext.setOrganizationPartialInfo({ ...appContext.organization, paymentSources: [...listOfPaymentSources, organizationCreated.data.data] });
          }
        }
      } else {
        organizationCreated = await axios.post(`${baseURL}/register-organization`, paramsNonVerified,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        console.log("register-org")
        console.info({ organizationCreated });

        if (organizationCreated && organizationCreated.data && organizationCreated.status === 200) {
          // console.info(`register-organization`, organizationCreated.data);
          setLoading(false);
          const { code, message } = organizationCreated.data.status;
          console.info({ code, message });
          setListOfPaymentSources(organizationCreated.data.data.paymentSources)
          setListOfPaymentSources(listOfPaymentSources.map((ps) => { return { ...ps, isPrimary: ps.id === showDefault ? 1 : 2 } }))

          setpaymentCount(prevCount => prevCount + 1)
          console.log("list of payment sources", listOfPaymentSources)
          setErrors(message);
          if (code === "bankAccount/pending-verification") {
            console.info(`code === 'bankAccount/pending-verification' ${code === "bankAccount/pending-verification"}`);
            resetPaymentSourceVerificationForm();
            resetBankaccountInfoForm();
            setShowMicroDepositForm(false);

            const paymentSources = organizationCreated.data.data.paymentSources;
            console.info({ paymentSources });
            // await appContext.setOrganizationPartialInfo({ ...appContext.organization, paymentSources, });
            await appContext.setVerifiedUser(organizationCreated.data.data.user);
            await appContext.setOrganization(organizationCreated.data.data.user.accessToken)
            localStorage.setItem('accessToken', organizationCreated.data.data.user.accessToken);
            localStorage.setItem('email', organizationCreated.data.data.user.email);
          }

          if (code === "organization/registered") {
            // const paymentSources = organizationCreated.data.data.paymentSources;
            // console.info({ paymentSources });
            // await appContext.setOrganizationPartialInfo({ ...appContext.organization, verified: true, paymentSources});
            // await appContext.setVerifiedUser(organizationCreated.data.data.user);
            // history.push(`/account/user-settings`);
            const paymentSources = organizationCreated.data.data.paymentSources;
            console.info({ paymentSources });
            await appContext.setVerifiedUser(organizationCreated.data.data.user);
            await appContext.setOrganization(organizationCreated.data.data.user.accessToken)
            localStorage.setItem('accessToken', organizationCreated.data.data.user.accessToken);
            localStorage.setItem('email', organizationCreated.data.data.user.email);
          }
        }
      }
    } catch (error) {
      console.info({ error });
      setLoading(false);
      if (error.response && error.response.data && error.response.data.status && error.response.data.status.message) setErrors(error.response.data.status.message);
    }
    // setTransactions(accountAttached.data.transactions.transactions);
  };

  const onSuccess = useCallback(async (token, metadata) => {
    console.log("on Success", appContext);
    await submitAccountInfo(token, metadata);
    // eslint-disable-next-line
  }, []);

  const config = {
    clientName: "Perkfix",
    env: "sandbox",
    product: ["auth", "transactions"],
    publicKey: "48c8a3d46b5f9a349f8a9e4019ee8e", // sandbox - taken from https://dashboard.plaid.com/team/keys
    onSuccess,
    // ...
  };

  const { open, ready, error } = usePlaidLink(config);
  // const { open, ready } = usePlaidLink(config);
  // console.info({error});

  const loader = (
    <Dimmer active inverted>
      <Loader size="large" inverted>
        Loading
      </Loader>
    </Dimmer>
  );

  const errorBlock = (
    <div className="ui error message">
      <div className="content">
        {/*<div className="header">There were some errors with your submission</div>*/}
        {errors}
        {/*<ul className="list">
                    <li className="content">You must include both a upper and lower case letters in your password.</li>
                    <li className="content">You need to select your home country.</li>
                </ul>*/}
      </div>
    </div>
  );

  const invalidCreditCardInfo = activePaymentMethod === "creditCard" && !acceptTermsAndConditions && (!cardHolderName || !cardNumber || !expiryMonth || !expiryYear || !cvc);

  const invalidBankAccountInfo = activePaymentMethod === "manualBankVerification" && !acceptTermsAndConditions && (!bankAccountCountry || !bankAccountHolderName || !bankAccountHolderType || !bankAccountRoutingNumber || !bankAccountNumber);
  const invalidPlaidConditions = activePaymentMethod === "plaid" && !(ready && acceptTermsAndConditions);

  const paymentOptions = (
    <>
      <h3>Choose payment method to fund Organization</h3>
      {activePaymentMethod === "plaid" && (<div className="ui message"><i className="info circle icon large" />At the moment PNC bank does not support instant verification.</div>)}
      {activePaymentMethod === "creditCard" && (<div className="ui message warning">The Credit card payment feature is not yet ready...</div>)}
      <section id="payment-methods">
        <div className={activePaymentMethod === "plaid" ? "ui segment method-block active" : "ui segment method-block"} onClick={(e) => setActivePaymentMethod("plaid")}>
          <h5>Bank Account (Login)</h5>
          <p>Verify & link your banking info via PLAID</p>
          <h6>No fees / instant</h6>
        </div>
        <div className={activePaymentMethod === "creditCard" ? "ui segment method-block active" : "ui segment method-block"} onClick={(e) => setActivePaymentMethod("creditCard")}>
          <h5>Credit Card</h5>
          <p>Use a credit card to fund your account</p>
          <h6>3% fee / instant</h6>
        </div>
        <div className={activePaymentMethod === "manualBankVerification" ? "ui segment method-block active" : "ui segment method-block"} onClick={(e) => setActivePaymentMethod("manualBankVerification")}>
          <h5>Bank Account (Manual)</h5>
          <p>Manually enter your bank account information</p>
          <h6>No fees / 3-4 business days</h6>
        </div>
      </section>
      {activePaymentMethod === "manualBankVerification" && bankAccountInfo}
      {activePaymentMethod === "creditCard" && creditCardInfo}
      <footer className="ui one column grid">
        <div className="column">
          <Checkbox className="terms-conditions-checkbox" checked={acceptTermsAndConditions} onChange={(e) => setAcceptTermsAndConditions(!acceptTermsAndConditions)} />
          By registering your account, you agree to our{" "}<a rel="noopener noreferrer" target="_blank" href="https://stripe.com/legal">Services Agreement{" "}</a>
          and the{" "}<a rel="noopener noreferrer" target="_blank" href="https://stripe.com/connect-account/legal">{" "}Payment Partner Agreement.</a>
        </div>
        <div className="column">
          <button className="ui button" onClick={() => {
            activePaymentMethod === "plaid" ? open() : activePaymentMethod === "manualBankVerification" ? submitAccountInfo() : submitCardInfo();

            { invalidBankAccountInfo ? setShowPaymentOptions(true) : setShowPaymentOptions(false); }
            { invalidCreditCardInfo ? setShowPaymentOptions(true) : setShowPaymentOptions(false); }
          }}
            disabled={invalidPlaidConditions && invalidBankAccountInfo && invalidCreditCardInfo}>Next
          </button>
          <button className="ui button" onClick={() => setShowPaymentOptions(false)}>Cancel</button>
        </div>
      </footer>
    </>
  );

  const updateDefaultPaymentMethod = async () => {
    setErrors("");
    const accessToken = localStorage.getItem("accessToken");
    try {
      const body = {
        stripeCustomerId: appContext.organization.stripeCustomer.id,
        indexSelected,
      };
      const fetchedData = await axios.post(`${baseURL}/update-default-method`, body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      console.info({ fetchedData });
      if (fetchedData.status == 200) {
        setShowDefault(indexSelected);
        setListOfPaymentSources(prevState => { return prevState.map(current => { return current.id === indexSelected ? { ...current, isPrimary: 1 } : { ...current, isPrimary: 2 } }) })

      }

      setOpen(false)
      // const data = fetchedData.data;
    } catch (err) {
      console.info({ err });
      setOpen(false)
    }
  };

  // const handleChangeSelection = () => {s
  //   const card = listOfPaymentSources.filter(cp => cp.isPrimary === 1)
  //   console.log("card", card)
  //   if (card[0].isPrimary === 1) {
  //     updateDefaultPaymentMethod(card[0].id);
  //   } else if (card.isPrimary === 2) {
  //     console.log("2")
  //   }
  //   setOpen(false)

  // }

  const handleCanelSelection = () => {
    setIndexSelected(null);
    setOpen(false)
    setListOfPaymentSources(listOfPaymentSources)
  }

  const handleDropdownChange = (id, value) => {
    console.log("value", value)
    console.log("id", id)
    if (value === 1) {
      setIndexSelected(id);
      setOpen(true)
      // setListOfPaymentSources(prevState => { return prevState.map(current => { return { ...current, isPrimary: 2 } }) })
      // setListOfPaymentSources(prevState => { return prevState.map(current => { return current.id === id ? { ...current, isPrimary: 1 } : current }) })
    }

  }

  const avatar = `${process.env.PUBLIC_URL}/assets/images/avatar/avatar-female.png`;

  const options = [
    { key: 1, text: 'Primary', value: 1 },
    { key: 2, text: 'Backup', value: 2 },
  ]
  const src = '../../../public/assets/images/avatar/avatar-female.png'
  const listOfCard = listOfPaymentSources !== undefined && listOfPaymentSources.map((paymentSource, index) => <>

    <Grid.Column>
      <Card raised={true} fluid key={index}>
        <div style={{ display: 'flex', padding: 10 }}>
          <img
            style={{ height: '80px', width: '80px', marginRight: 10 }}
            src={avatar}
          />
          <div style={{ flexGrow: 1, alignSelf: 'center' }}>
            {
              paymentSource.object === 'card' ?
                <CardContent>
                  <Card.Header>{paymentSource.brand} **** {paymentSource.last4}</Card.Header>
                  <Card.Meta>{paymentSource.cardHolderName}</Card.Meta>
                </CardContent>
                :
                <CardContent>
                  <Card.Header>{paymentSource.bank_name} **** {paymentSource.last4}</Card.Header>
                  <Card.Meta>{paymentSource.account_holder_name}</Card.Meta>
                </CardContent>
            }

          </div>
        </div>
        <Card.Content extra>
          <Dropdown options={options} selection onChange={(e, { value }) => paymentSource.status === 'verified' && handleDropdownChange(paymentSource.id, value)} disabled={paymentSource.isPrimary === 1 || (paymentSource.object === 'bank_account' && paymentSource.status !== 'verified') ? true : false} value={paymentSource.isPrimary === 1 ? 1 : 2}
          />
          <div style={{ float: 'right' }}>
            <Button basic color='red' onClick={() => deletePaymentSource(paymentSource.id)} size='tiny' disabled={paymentSource.isPrimary === 1}>
              Remove
          </Button>
            {paymentSource.status !== 'verified' && paymentSource.object === "bank_account" && <Button basic color='black' onClick={() => onVerifyPaymentSource(paymentSource.id, index)} size='tiny'>
              Verify
          </Button>}
            <Modal
              dimmer='blurring'
              onClose={() => setOpen(false)}
              onOpen={() => setOpen(true)}
              open={isopen}
            >
              <Modal.Header>Payment Options</Modal.Header>
              <Modal.Content>
                <p>Are you sure for this Change?</p>
              </Modal.Content>
              <Modal.Actions>
                <Button negative onClick={() => handleCanelSelection()}>
                  No
          </Button>
                <Button positive onClick={() => updateDefaultPaymentMethod()}>
                  Yes
          </Button>
              </Modal.Actions>
            </Modal>

            <Modal
              dimmer="blurring"
              onClose={() => setShowMicroDepositForm(false)}
              onOpen={() => setShowMicroDepositForm(true)}
              open={showMicroDepositForm}
            >
              <Modal.Content>
                {microDepositForm}
              </Modal.Content>
            </Modal>


          </div>

        </Card.Content>
      </Card>
    </Grid.Column>
  </>
  )
  // console.log("moodle", isopen)
  return (
    <Container>
      {loading ? loader : ""}
      {errors ? errorBlock : ""}

      <Grid columns={2} padded>
        {listOfPaymentSources !== undefined && listOfPaymentSources.length ? listOfCard : null}
        {paymentCount < 6 && paymentCount > 0 && <Grid.Column>

          {paymentCount && <div style={{ height: '160px', width: '100%', border: 'gray 1px dashed', display: 'grid', textAlign: 'center', alignContent: 'center', background: 'transparent' }}>
            <button className="ui button" style={{ background: 'transparent', color: 'black' }} onClick={() => {

              if (paymentCount <= 6) {
                resetBankaccountInfoForm();
                resetCardInfoForm();
                {
                  setShowPaymentOptions(true);
                }

              } else console.log("Cant add More payment methods")
            }}>Add more payment methods
              </button>
          </div>}

        </Grid.Column>}
      </Grid>
      {(!appContext.organization.paymentSources || showPaymentOptions) && paymentOptions}
      {/* {showPaymentOptions === true && paymentOptions} */}
    </Container>

    // <div id="payment-setup-page" className="sub-page">
    //   {loading ? loader : ""}
    //   {errors ? errorBlock : ""}
    //   {listOfPaymentSources && (<section id="existing-payment-methods">
    //     <h3 style={{ marginLeft: '2%' }}>Your existing payment sources:</h3>

    //     {listOfPaymentSources.map((paymentSource, index) => {
    //       return (<div className="ui segment"
    //         style={{
    //           width: '97%', marginLeft: '1.5%', marginRight: '1.5%', paddingLeft: '2%', paddingBottom: 10, backgroundColor: 'transparent',
    //           paddingBottom: 5, marginTop: '2%', borderWidth: 1, borderColor: 'rgba(128, 149, 167, 1)', borderStyle: 'solid', marginBottom: 10
    //         }}>
    //         {paymentSource.object === "bank_account" && (
    //           <aside key={paymentSource.id}>
    //             <ul>
    //               <li>Account Holder Name:{" "}{paymentSource.account_holder_name}</li>
    //               <li>Bank Name: {paymentSource.bank_name}</li>
    //               <li>Account Number last4: {paymentSource.last4}</li>
    //               <li>Status:{" "}{paymentSource.status !== "verified" ? "pending" : "verified"}</li>
    //             </ul>
    //             {paymentSource.status !== "verified" && (
    //               <button className="ui button primary" disabled={showMicroDepositForm} onClick={(e) => onVerifyPaymentSource(paymentSource.id, index)}>Verify</button>
    //             )}
    //             {paymentSource.status !== "verified" && index === indexSelected && showMicroDepositForm && microDepositForm}

    //             {/* {showDefault === paymentSource.id ? (
    //                   <h5 style={{ color: "blue" }}>Default</h5>
    //                 ) : (
    //                   <button
    //                     className="ui button"
    //                     onClick={() => {
    //                       updateDefaultPaymentMethod(paymentSource.id);
    //                       setShowDefault(paymentSource.id);
    //                     }}
    //                   >
    //                     Make it default
    //                   </button>
    //                 )} */}

    //             {showDefault === paymentSource.id ? (
    //               <h5 style={{ color: "blue" }}>Default</h5>
    //             ) : paymentSource.status === "verified" ? (
    //               <button className="ui button" onClick={() => {
    //                 updateDefaultPaymentMethod(paymentSource.id);
    //                 setShowDefault(paymentSource.id);
    //               }}>Make it default</button>
    //             ) : null}
    //             {showDefault === paymentSource.id ? null :
    //               <button
    //                 className="ui button"
    //                 onClick={() => {
    //                   deletePaymentSource(paymentSource.id);
    //                   // setShowDefault(paymentSource.id);
    //                 }}
    //               >
    //                 Delete
    //                   </button>}

    //             {/* {showMicroDepositForm && microDepositForm} */}
    //           </aside>
    //         )}

    //         {paymentSource.object === "card" && (
    //           <aside key={paymentSource.id}>
    //             <ul>
    //               <li>Brand: {paymentSource.brand}</li>
    //               <li>Funding: {paymentSource.funding}</li>
    //               <li>Account Number last4: {paymentSource.last4}</li>
    //               {/* <li>
    //                     Status:{" "}
    //                     {paymentSource.status !== "verified"
    //                       ? "pending"
    //                       : "verified"}
    //                   </li> */}
    //             </ul>
    //             {/* {paymentSource.status !== "verified" && (
    //                   <button
    //                     className="ui button primary"
    //                     disabled={showMicroDepositForm}
    //                     onClick={(e) => onVerifyPaymentSource(paymentSource.id)}
    //                   >
    //                     Verify
    //                   </button>
    //                 )} */}

    //             {showDefault === paymentSource.id ? (
    //               <h5 style={{ color: "blue" }}>Default</h5>
    //             ) : (
    //                 <button className="ui button" onClick={() => {
    //                   updateDefaultPaymentMethod(paymentSource.id);
    //                   {
    //                     setShowDefault(paymentSource.id);
    //                   }
    //                 }}
    //                 >Make it default
    //                 </button>
    //               )}
    //             {showDefault === paymentSource.id ? null :
    //               <button className="ui button" onClick={() => { deletePaymentSource(paymentSource.id); }}>Delete</button>}
    //           </aside>
    //         )}
    //       </div>
    //       );
    //     }
    //     )}
    //     {/* {showMicroDepositForm && microDepositForm} */}
    //   </section>
    //   )}
    //   <br></br>
    //   <div className="column">
    //     <button className="ui button" onClick={() => {
    //       resetBankaccountInfoForm();
    //       resetCardInfoForm();
    //       {
    //         setShowPaymentOptions(true);
    //       }
    //     }}>Add more payment methods
    //     </button>
    //   </div>
    //   {/* {!appContext.organization.paymentSources && paymentOptions} */}
    //   {showPaymentOptions === true && paymentOptions}
    // </div>
  );
};
